export class IncorrectActivationKeyError extends Error {
  constructor() {
    super(
      `The integration has an incorrect ActivationKey or this hostname is not connected with the owner account, please check the settings in the Trillion Dashboard`
    );
    this.name = "IncorrectActivationKeyError";
  }
}
